module.exports = __webpack_public_path__ + "static/media/desktop.d6d6d91.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Sweeping/desktop.mp4
// module id = tk8w
// module chunks = 1